<template>
  <v-dialog
    v-model="isModal"
    width="600px"
    @click:outside="onClickCloseModal()"
  >
    <v-card>
      <v-card-title>
        <span class="">เพิ่มโปรแกรมบัญชี</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" id="settingErp" v-model="valid" @submit="submit">
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
            >
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                v-model="selected"
                :items="items"
                label="Program"
                item-value="type"
                item-text="name"
                outlined
                return-object
                @change="changeSelected"
              ></v-select>
            </v-col>
          </v-row>
          <div v-if="form.type === 1">
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.apiKey" outlined
                  label="API Key"
                  :disabled="loading"
                  :rules="rules.inputRule"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.serverName" outlined
                  label="Database sever name"
                  :disabled="loading"
                  :rules="rules.inputRule"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.databaseName" outlined
                  label="Database name"
                  :disabled="loading"
                  :rules="rules.inputRule"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.userName" outlined
                  label="Database username"
                  :disabled="loading"
                  :rules="rules.inputRule"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="form.password" outlined
                  label="Database password"
                  :disabled="loading"
                  :rules="rules.inputRule"
                  required
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div v-if="form.type === 2">
            <v-text-field
              v-model="form.pathDatabase" outlined
              label="Path database"
              :disabled="loading"
              :rules="rules.inputRule"
              required
            ></v-text-field>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="black"
          text
          @click="onClickCloseModal()"
        >
          <v-icon color="#000" left class="icon">mdi-close-circle-outline</v-icon>
          ยกเลิก
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          type="submit" form="settingErp"
        >
          <v-icon color="#6ec39b" left class="icon">mdi-plus-circle-outline</v-icon>
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from "vuex";

const _ = require('lodash');

export default {
  name: 'Settings',
  props: ["erpId"],
  computed: mapState({
    loading: state => state.databasesByCompany.loading,
    isModal: state => state.databasesByCompany.isModal,
  }),
  data: function () {
    return {
      showPassword: false,
      valid: true,
      form: {
        apiKey: "",
        timeCreated: new Date(),
        userName: "",
        password: "",
        serverName: "",
        databaseName: "",
        pathDatabase: "",

        type: 1,
        programName: 'SAP Business One',
      },
      selected: {type: 1, name: 'SAP Business One'},
      items: [
        {type: 1, name: 'SAP Business One'},
        {type: 2, name: 'Express'},
      ],

      rules: {
        inputRule: [
          v => (!!v) || 'กรุณากรอกข้อมูล',
        ],
      },
    };
  },
  methods: {
    onClickCloseModal: function () {
      this.$store.dispatch('databasesByCompany/setModal')
    },
    submit: function (e) {
      e.preventDefault()
      let dataObject = _.cloneDeep(this.form)
      let companyId = this.$route.params.companyId
      if (companyId) {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('databasesByCompany/updateData', {
            companyID: companyId,
            data: dataObject,
            erpID: this.erpId
          }).then(() => {
            this.$store.dispatch('databasesByCompany/setModal')
            this.$refs.form.resetValidation()
          })
        }
      }
    },
    clearForm: function () {
      this.form.apiKey = ""
      this.form.timeCreated = new Date()
      this.form.userName = ""
      this.form.password = ""
      this.form.serverName = ""
      this.form.databaseName = ""
      this.form.pathDatabase = ""

      this.$refs.form.resetValidation()
    },
    query: async function () {
      let form = await this.$store.dispatch('databasesByCompany/getErpObject', {companyID: this.$route.params.companyId, id: this.erpId}).then((res) => _.cloneDeep(res))
      this.form = form

      this.selected = {type: form.type, programName: form.programName}
    },
    changeSelected: function (selectObj) {
      if (selectObj.type !== this.form.type) {
        this.form.type = selectObj.type
        this.form.programName = selectObj.name
        this.clearForm()
      }
    }
  },
  watch: {
    isModal: {
      handler: function () {
        if (this.isModal && this.erpId) {
          this.query()
        }
        if (!this.isModal) {
          this.form.type = 1
          this.form.programName = 'SAP Business One'

          this.selected = {type: 1, name: 'SAP Business One'}
          this.clearForm()
        }
      }
    },
  },
}
</script>

<style lang="scss">
  .icon {
    font-size: 24px !important;
  }
</style>
